import { ChangeEvent } from 'react';

import { CustomCheckBox, CustomInput } from '../../../shared/uiComponents';
import { useSoapNoteFieldDisabled } from '../helpers';
import { TimeInfo } from '../components';
import { ACTIONS, ActionProperties, IntroCallState } from './introCallReducer';

const IntroCallData = ({
	data,
	setData,
}: {
	data: IntroCallState;
	setData: (action: ActionProperties) => void;
}) => {
	const { getFieldDisabled } = useSoapNoteFieldDisabled();

	const attendeesHandler = (event: ChangeEvent<HTMLInputElement>) => {
		setData({ payload: event.target.value, type: ACTIONS.setAttendees });
	};

	const noteHandler = (event: ChangeEvent<HTMLInputElement>) => {
		setData({ payload: event.target.value, type: ACTIONS.setNote });
	};

	const callTookPlaceHandler = (event: ChangeEvent<HTMLInputElement>) => {
		setData({ payload: event.target.checked, type: ACTIONS.setCallTookPlace });
	};

	return (
		<>
			<TimeInfo disabled={getFieldDisabled('startTime')} />
			<CustomInput
				label="Attendees:"
				value={data.attendees ?? ''}
				onChange={attendeesHandler}
				className="marginBottom16"
				multiline
				disabled={getFieldDisabled('attendees')}
			/>
			<CustomInput
				label="Note:"
				value={data.note ?? ''}
				onChange={noteHandler}
				className="marginBottom16"
				multiline
				disabled={getFieldDisabled('note')}
			/>
			<CustomCheckBox
				item={{ id: 'callTookPlace', label: 'Call took place', checked: data.callTookPlace, disabled: getFieldDisabled('callTookPlace') }}
				onChange={callTookPlaceHandler}
				style={{ marginBottom: 16 }}
			/>
		</>
	);
};

export default IntroCallData;
